import { Loadable, KeyValueSet } from "./helpers";
import { PaymentAgregator } from "./consumer/payments";
import { CustomQuery } from "./query";
import {PaginationState, RowSelectionState, SortingState} from "@tanstack/react-table";

export interface PanelSettings {
    projectName: string;
    title?: string;
    baseUrl: string;
    aggregators: PaymentAgregator[];
    paymentCurrency: string;
    captchas: CaptchaSettings[];
    isActive: boolean;
    defaultLang: string;
    selectedLanguage?: string;
    googleTagId?: string;
    ymId?: number;
    mailRuCounterId?: string;
}

export interface PanelInfo {
    ProjectInfo: PanelSettings;
    Queries: CustomQuery[];
}

export interface LanguageInfo {
    code: string;
    name: string;
    hash: string;
}

export interface PanelLanguage {
    name: string;
    code: string;
    hash: string;
    strings: Record<string, string>;
}

export interface BreadcrumbInfo {
    code: string;
    name?: string | null;
    link?: string;
}

export interface PanelTableState {
    page: number;
    sizePerPage: number;
    search?: string | null;
    sortField?: string;
    sortOrder?: string;
    selected?: (string | number)[]
}

export interface ReactTableState {
    sorting: SortingState;
    pagination: PaginationState;
    rowSelection: RowSelectionState;
    globalFilter?: any;
}

export interface PanelTableData<T> {
    page: number;
    sizePerPage: number;
    totalSize: number;
    search?: string | null;
    sortField?: string;
    sortOrder?: string;
    data: T
}

export interface CaptchaSettings {
    id: string;
    type: ECaptchaType;
    publicKey: string;
}

export enum ECaptchaType {
    Google,
    HCaptcha,
    Yandex,
    Turnstile
}

export type PanelTableStateStore = KeyValueSet<PanelTableState>;
export type ReactTableStateStore = KeyValueSet<Partial<ReactTableState>>;

export type PanelBreadcrumbStore = KeyValueSet<BreadcrumbInfo>;

export type PanelLanguages = KeyValueSet<Loadable<PanelLanguage | undefined>>;

export type PanelModalStateStore = KeyValueSet<boolean>;